import { DailyUtilization } from './daily-utilizations';

export class Utilization {
  public dailyUtilizations: DailyUtilization[] = [];
  public priceWindowId?: number;
  public isExpanded = false;
  public uiIndex: number = Math.floor(Math.random() * 50000);

  constructor() {
    this.dailyUtilizations = [];
  }
}
